import { render, staticRenderFns } from "./externalPenyakitRajal.vue?vue&type=template&id=167e8afa"
import script from "./externalPenyakitRajal.vue?vue&type=script&lang=js"
export * from "./externalPenyakitRajal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167e8afa')) {
      api.createRecord('167e8afa', component.options)
    } else {
      api.reload('167e8afa', component.options)
    }
    module.hot.accept("./externalPenyakitRajal.vue?vue&type=template&id=167e8afa", function () {
      api.rerender('167e8afa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/external/pelayanan/externalPenyakitRajal.vue"
export default component.exports